/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { HandoverOfferDtoModel } from './handover-offer-dto.model';
import { VehicleVoModel } from '@well/delivery-libs/vehicle-management/domain';
import { DriverVoModel } from '@well/delivery-libs/driver-management/domain';

export class RoutingSolutionVoModel extends JSONable {
  uuid: string | undefined = undefined;

  shipmentGroupUuid?: string;

  serviceProviderUuid?: string;

  serviceProviderName?: string;

  currency?: string;

  costValue?: string;

  details?: string;

  vehicleTypeValue?: string;

  licensePlate?: string;

  driverName?: string;

  createdBy?: string;

  availableUntil?: string;

  handoverOffers?: HandoverOfferDtoModel[];

  spRoutingSolutionUuid: string | undefined = undefined;

  originalOfferUuid: string | undefined = undefined;

  originalOfferAccepted: boolean | undefined = undefined;

  originalOfferExpired: boolean | undefined = undefined;

  paymentTimeLimit: string | undefined = undefined;
}
